module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_photogallery_3.4c097a28.jpg";